<div class="switch-status">
    <button nz-button nz-dropdown [nzDropdownMenu]="statusMenu" [nzLoading]="statusLoading" nzType="text"
        class="status-button">
        {{ taskInfo.swimLaneName }}
        <span nz-icon nzType="down"></span>
    </button>
    <nz-dropdown-menu #statusMenu="nzDropdownMenu">
        <ul nz-menu>
            <li nz-menu-item *ngFor="let statusItem of swimLaneList"
                [nzDisabled]="statusItem.id === taskInfo.swimLaneId" (click)="changeTaskStatus(statusItem)">
                {{ statusItem.swimLaneName }}
            </li>
        </ul>
    </nz-dropdown-menu>
</div>

<nz-collapse nzExpandIconPosition="end" class="collapse-panel">
    <nz-collapse-panel nzHeader="Details" [nzActive]="true">
        <div class="panel-content">
            <div *ngFor="let field of defaultFields" class="field-item">
                <div class="item-label">{{ field.fieldName }}</div>
                <div class="item-value">
                    <app-field-item
                        [taskInfo]="taskInfo"
                        [accountList]="accountList"
                        [field]="field"
                        [projectMembers]="projectMembers"
                        [templateAllFields]="templateAllFields"
                        (saveField)="saveFieldFn($event)"
                        (taskInfoChange)="onTaskInfoChange($event)"
                    >
                    </app-field-item>
                </div>
            </div>
        </div>
    </nz-collapse-panel>
</nz-collapse>

<nz-collapse nzExpandIconPosition="end" class="collapse-panel" *ngIf="moreFields && moreFields.length > 0">
    <nz-collapse-panel nzHeader="More fields" nzActive="true">
        <div class="panel-content">
            <div *ngFor="let field of moreFields" class="field-item">
                <div class="item-label">{{ field.fieldName }}</div>
                <div class="item-value">
                    <app-field-item
                        [taskInfo]="taskInfo"
                        [field]="field"
                        [accountList]="accountList"
                        [projectMembers]="projectMembers"
                        [templateAllFields]="templateAllFields"
                        (saveField)="saveFieldFn($event)"
                        (taskInfoChange)="onTaskInfoChange($event)"
                    >
                    </app-field-item>
                </div>
            </div>
        </div>
    </nz-collapse-panel>
</nz-collapse>
